// extracted by mini-css-extract-plugin
export default {"page":"PageList_page__9U5LU"};